<template>
  <div class="herobanner uptop">
    <div class="banner-contents">
      <span class="static-text">{{ this.currentText }}</span>

      <!-- <form class="searchbar-wrapper" @submit="handleSearch">
        <input
          class="searchbar"
          type="text"
          placeholder="Search Hsmaere"
          v-model="searchText"
        />

        <a-icon @click="handleSearch" type="search" class="search-icon" />
      </form> -->

      <!-- <div class="sections-container">
        <div class="sections-wrapper" v-for="item in sections" :key="item.id">
          <img class="sections-image" :src="item.image" />

          <div class="sections-name" @click="getVUrl(item.name)">
            {{ item.name }}
          </div>
        </div>
      </div> -->
    </div>

    <carousel
      :perPage="1"
      :autoplayTimeout="5000"
      :autoplay="true"
      :paginationEnabled="false"
      :loop="true"
      :centerMode="true"
      :autoplayHoverPause="true"
    >
      <slide class="item-wrap default" v-if="!imagesloaded">
        <div class="banner-wrapper">
          <img
            src="https://khaanpin.com.np/images/shop/fish-banner_ZJvDg5q.jpg"
            alt=""
          />
        </div>
      </slide>

      <slide
        class="item-wrap"
        v-else
        v-for="(item, index) in bannerItems"
        :key="index + item.title"
      >
        <div class="banner-wrapper">
          <!-- <div class="hero-text">
            <h1>{{ item.title }}</h1>
            <h2>{{ item.details }}</h2>
            <button
              @click="bannerURL(item.redirection_type, item.redirection_code)"
            >
              {{ item.button_text }}
            </button>
          </div> -->
          <!-- <div class="banner-contents">
            <form class="searchbar-wrapper" @submit="handleSearch">
              <input
                class="searchbar"
                type="text"
                placeholder="Search Here"
                v-model="searchText"
              />

              <a-icon
                @click="handleSearch"
                type="search"
                :style="{
                  color: '#000',
                  position: 'absolute',
                  fontSize: '20px',
                  marginRight: '10px',
                }"
              />
            </form>

            <div class="sections-container">
              <div
                class="sections-wrapper"
                v-for="item in sections"
                :key="item.id"
              >
                <img class="sections-image" :src="item.image" />

                <div class="sections-name" @click="getVUrl(item.name)">
                  {{ item.name }}
                </div>
              </div>
            </div>
          </div> -->

          <img :src="item.image" alt="" />
          <!-- <img
            src="https://khaanpin.com.np/images/shop/fish-banner_ZJvDg5q.jpg"
            alt=""
          /> -->
        </div>
      </slide>
    </carousel>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import { Carousel, Slide } from "vue-carousel";
import Item from "./Item.vue";
import { GetBannerService } from "./../../../services/items.service";
import { LocationId } from "../../../services/storage.service";
import { SectionService } from "../../../services/items.service";
import router from "../../../router";

export default {
  name: "BannerSlider",
  components: {
    Carousel,
    Slide,
    Item,
    GetBannerService,
  },
  props: ["vName", "hasV"],
  data() {
    const that = this;

    setInterval(() => {
      that.currentIndex = ++that.currentIndex % that.textList.length;
    }, 3000);

    return {
      bannerItems: [],
      imagesloaded: 0,
      currentTag: "combo",
      sections: [],
      searchText: "",
      // textList: [
      //   "Eat. Repeat.",
      //   "Hami Chau Ni.",
      //   // "Something For Everyone!",
      //   "Khaanpin Bhayo?",
      //   "All Day, All Night.",
      // ],
      currentIndex: 0,
    };
  },
  created() {
    // console.log(this.currentTag)
    // console.log(LocationId);
    this.loadBanner();
    this.loadSection();
  },
  watch: {
    locationId: function (newLocationId, oldLocationId) {
      this.loadSection();
    },
  },
  computed: {
    ...mapGetters(["locationId"]),

    currentText() {
      return this.textList[this.currentIndex];
    },
  },
  methods: {
    loadBanner: function () {
      this.currentTag = this.$route.params.slug;
      if (this.currentTag == undefined) this.currentTag = "";

      GetBannerService.getItems(LocationId.getLocationId(), this.currentTag)
        .then((response) => {
          let banner = response.data.filter((data) => data.type === "banner");
          this.bannerItems = banner;
          this.imagesloaded = 1;
        })
        .catch((err) => console.log(err));
    },
    bannerURL: function (type, slug) {
      let url = "";
      if (type == "search") {
        url = "./s/" + slug;
        window.open(url, "_blank");
      } else if (type == "list") {
        url = "./l/" + slug;
        window.open(url, "_blank");
      } else if (type == "item") {
        url = "./i/" + slug;
        window.open(url, "_blank");
      } else if (type == "section") {
        url = "./c/" + slug;
        window.open(url, "_blank");
      } else if (type == "url") {
        url = slug;
        window.open(url, "_blank");
      }
    },
    loadSection: function () {
      SectionService.getItems(parseInt(LocationId.getLocationId()))
        .then((data) => {
          this.sections = data.data;
        })
        .catch((err) => console.log(err));
    },
    getVUrl: function (item) {
      if (LocationId.getLocationId() == 1) {
        router.push("/ktm/c/" + item);
      } else if (LocationId.getLocationId() == 2) {
        router.push("/pkr/c/" + item);
      }
    },
    handleSearch: function () {
      if (LocationId.getLocationId() == 1) {
        this.$router.replace({
          name: "Search",
          params: { loc: "ktm" },
          query: { q: this.searchText },
        });
      } else if (LocationId.getLocationId() == 2) {
        this.$router.replace({
          name: "Search",
          params: { loc: "pkr" },
          query: { q: this.searchText },
        });
      }
    },
  },
  watch: {
    $route: function (n, o) {
      this.currentTag = this.pageName = this.$route.params.slug;
      this.loadBanner();
    },

    locationId: function (newLocationId, oldLocationId) {
      // console.log(newLocationId);
      // console.log("Location Changed");
      this.loadBanner();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";
.filter-button {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  padding-bottom: 0px;
  button {
    height: 40px;
    margin-bottom: 10px;
    line-height: 28px;
    border: 1px solid #e7e9f3;
    font-size: 13px;
    font-weight: 600;
    border-radius: 30px;
    -moz-background-clip: padding;
    -webkit-background-clip: padding-box;
    background-clip: padding-box;
    padding: 0 20px;
    text-transform: uppercase;
    background-color: transparent;
    -ms-transition: all 500ms ease;
    -webkit-transition: all 500ms ease;
    transition: all 500ms ease;
    margin-right: 20px;
    &:last-child {
      margin-right: 0;
    }
    &.active {
      color: #fff;
      background-color: $brand-color;
    }
    &:hover {
      color: #fff;
      background-color: $brand-color;
    }
    &:focus {
      outline: none;
    }
  }
}
.item-wrap {
  position: relative;
  cursor: pointer;
  overflow: hidden;
  background: transparent;
}

.banner-wrapper {
  position: relative;
  display: flex;
  justify-content: center;
  img {
    width: 100%;
  }
  .hero-text {
    position: absolute;
    padding: 50px;
    top: 50%;
    transform: translateY(-50%);
    font-family: sans-serif;

    h1 {
      color: #fff;
      font-weight: 900;
      margin-bottom: 0;
      font-size: 55px;
      text-shadow: 1px 2px rgba(0, 0, 0, 0.3);
    }
    h2 {
      color: #fff;
      margin-top: px;
    }
    button {
      border: 2px solid #fff;
      background: transparent;
      color: #fff;
      padding: 10px 15px;
      font-weight: bold;
      text-transform: uppercase;
      margin-top: 20px;
    }
  }
}
.sections-container {
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  cursor: pointer;
}
.sections-wrapper {
  width: 24%;
  margin: 10px;
  height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background: rgba(0, 0, 0, 0.9);
  border-radius: 10px;
  :hover {
    opacity: 0.6;
  }
}
.sections-image {
  height: 100%;
  width: 100%;
  border-radius: 10px;
  background-size: cover;
}
.sections-name {
  position: absolute;
  color: #fff;
  border: 5px solid #fff;
  font-size: 26px;
  font-weight: 800;
  text-transform: uppercase;
  background-color: rgba(255, 255, 255, 0.1);
  height: 100%;
  width: 100%;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  letter-spacing: 2px;
}
.banner-contents {
  margin-top: -100px;
  position: absolute;
  z-index: 999;
  width: 95% !important;
  display: flex;
  flex-direction: column;
  align-items: center;

  .static-text {
    font-size: 50px;
    font-weight: 800;
    color: #ffffff;
    text-shadow: 0px 0px 4px rgba(0, 0, 0, 0.9);
    margin-bottom: 20px;
    margin-top: 10px;
    text-align: center;
    transition: all 0.5ms ease-in-out;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .searchbar-wrapper {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60%;
  }
  .searchbar {
    height: 45px;
    width: 100%;
    border: 1px solid #fff;
    border-radius: 4px;
    background-color: rgba(255, 255, 255, 1);
    color: #000;
    padding-left: 20px;
    outline: none;
    font-size: 16px;
    box-shadow: 0 0 9px 0px rgba(0, 0, 0, 0.1);
  }
  .searchbar:focus {
    background-color: rgba(255, 255, 255, 1);
  }
  .search-icon {
    font-size: 20px;
    position: absolute;
    display: flex;
    align-self: center;
    right: 10px;
  }
  ::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: #000;
    opacity: 1; /* Firefox */
  }
  :-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #fff;
  }
  ::-ms-input-placeholder {
    /* Microsoft Edge */
    color: #fff;
  }
}
.herobanner {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

@media only screen and (max-width: 740px) {
  .banner-contents {
    margin-top: -10px;
    .static-text {
      font-size: 36px;
      font-weight: 800;
      color: #ffffff;
      text-shadow: 0px 0px 4px rgba(0, 0, 0, 0.9);
    }

    .searchbar {
      height: 40px;
      width: 100%;
    }
  }

  .banner-wrapper {
    position: relative;
    display: flex;
    justify-content: center;
    img {
      width: 100%;
      height: 640px;
    }
  }

  .sections-container {
    display: grid;
    justify-content: space-evenly;
    justify-items: center;
    align-content: space-evenly;
    align-items: center;
    grid-template-columns: 50% 50%;
    grid-template-rows: 50% 50%;
    .sections-wrapper {
      width: 80%;
      height: 110px;

      .sections-name {
        font-size: 18px;
      }
    }
  }
}

@media only screen and (max-width: 1024px) {
  .banner-contents {
    margin-top: 90px;
    .static-text {
      font-size: 34px;
      font-weight: 800;
      color: #ffffff;
      text-shadow: 0px 0px 4px rgba(0, 0, 0, 0.9);
    }
  }

  .banner-wrapper {
    position: relative;
    display: flex;
    justify-content: center;
    img {
      width: 100%;
      height: 640px;
    }
  }

  .sections-container {
    margin-top: 43px;
    display: grid;
    justify-content: space-evenly;
    justify-items: center;
    align-content: space-evenly;
    align-items: center;
    grid-template-columns: 50% 50%;
    // grid-template-rows: 50% 50%;
    .sections-wrapper {
      width: 80%;
      height: 110px;

      .sections-name {
        font-size: 18px;
      }
    }
  }
}

@media only screen and (max-width: 740px) {
  .sections-container {
    grid-template-rows: 50% 50%;
  }
}
</style>
